/**
 * Rejection reasons, with the explanation shown publicly on /pravidla.
 *
 * The keys must stay in step with REJECT_REASONS in
 * apps/api/src/lib/schemas.ts — the API validates against its copy, this one
 * renders the moderator's radio list and the public rules from the same data,
 * so a submitter reads the exact bar their pin is judged against.
 *
 * A test asserts the two key sets match; see apps/web/test/reject-reasons.test.ts.
 */
export interface RejectReasonInfo {
  label: string;
  explanation: string;
}

export const REJECT_REASONS: Record<string, RejectReasonInfo> = {
  'osobni-udaje': {
    label: 'Obsahuje osobní údaje třetích osob',
    explanation:
      'Jméno, adresa bytu, registrační značka, popis konkrétního člověka nebo cokoli, podle čeho lze někoho identifikovat. Popište problém, ne osobu.',
  },
  'utok-na-osobu': {
    label: 'Útok na konkrétní osobu',
    explanation:
      'Urážky, obvinění a osobní spory. Týká se to i politiků a úředníků — kritika rozhodnutí ano, útok na člověka ne.',
  },
  'mimo-kompetenci': {
    label: 'Mimo kompetenci hlavního města',
    explanation:
      'Věci, které město ani městská část nemohou ovlivnit — například celostátní legislativa nebo spory mezi sousedy. Mapa má vést ke konkrétnímu řešení.',
  },
  duplicita: {
    label: 'Duplicita existujícího podnětu',
    explanation:
      'Stejný problém na stejném místě už na mapě je. Podpořte prosím ten existující — tím mu dodáte váhu, kterou by druhý záznam rozmělnil.',
  },
  zneuziti: {
    label: 'Spam, reklama nebo zneužití',
    explanation:
      'Komerční sdělení, opakované zahlcování mapy, vulgarity nebo body zjevně umístěné náhodně.',
  },
  'mimo-prahu': {
    label: 'Místo leží mimo Prahu',
    explanation: 'Mapa pokrývá území hlavního města Prahy.',
  },
  nesrozumitelne: {
    label: 'Nesrozumitelný nebo prázdný podnět',
    explanation:
      'Z textu není poznat, o jaký problém jde. Rádi ho zveřejníme, pokud ho pošlete znovu s popisem.',
  },
};

export type RejectReasonKey = keyof typeof REJECT_REASONS;
